import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import CheckoutContext from "../contexts/CheckoutContext";
import MainTitle from "../components/MainTitle";
import WaMeLink from "../components/WaMeLink";



const PaymentInProcess = () => {

    const navigate = useNavigate();

    const { clientData } = useContext(CheckoutContext);

    return (
        <div className="min-h-screen bg-[#f7f4ef] pb-10">

            {/* Header */}
            <MainTitle />

            {/* Estado */}
            <div className="px-4 pt-6 text-center">
                <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-3">
                    <svg className="w-7 h-7 text-amber-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                    </svg>
                </div>
                <h1
                    className="text-[22px] font-bold text-[#2a1419] leading-tight"
                    style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
                >
                    Atención {clientData.name}
                </h1>
            </div>

            {/* Detalle */}
            <div className="mx-3 mt-5 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">
                <div className="px-4 py-4 flex flex-col gap-2">
                    <p className="text-[13px] text-[#2a1419] leading-relaxed">
                        Tu pedido no ha podido ser procesado, el pago ha sido rechazado.
                    </p>
                    <p className="text-[13px] text-gray-500 leading-relaxed">
                        Contáctanos si necesitas asistencia. Agradecemos tu comprensión y preferencia.
                    </p>
                </div>
            </div>

            {/* Reintentar */}
            <div className="px-4 mt-4">
                <button
                    onClick={() => navigate("/checkout/info")}
                    className="w-full py-3 rounded-xl text-sm font-semibold bg-[#8c1d2f] hover:bg-[#a82a42] active:scale-[0.98] text-[#f5f0e8] shadow-md shadow-[#8c1d2f]/20 transition-all duration-150"
                >
                    Volver a intentar
                </button>
            </div>

            <WaMeLink />
        </div>
    );
}

export default PaymentInProcess;
